export default __webpack_public_path__ + "4c251a4107d243958b7a4815132593c0.webp";